export default "__VITE_ASSET__C7Kz7RSx__"